import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates-assets']['GET'];

type Input = {
  page: number;
  perPage?: number;
  searchTerm?: string;
};

type Output = ThisApi['response'];

const getDynamicPdfTemplatesAssets = async ({ page, perPage, searchTerm }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.get('/dynamic-pdf-templates-assets', {
      params: {
        page,
        perPage,
        searchTerm,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dynamic PDF templates:', error);
    throw error;
  }
};

export default getDynamicPdfTemplatesAssets;
